import { LogManager } from '../../../../common/port/log/log.manager.port';
import { CategoryMetricsTotalWholeTeamParentAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/category/category-metrics-total-whole-team-parent.aggregate-root.mapper';
import { GetCategoryMetricsTotalsWholeTeamRequestDto } from '../../../dtos/team-metrics/category/get-category-metrics-totals-whole-team.request.dto';
import { GetCategoryMetricsTotalsResponseDto } from '../../../dtos/team-metrics/category/get-category-metrics-totals.response.dto';
import { GetCategoryMetricsTotalWholeTeamQuery } from '../../../queries/team-metrics/category/get-category-metrics-totals-whole-team.query';

export class GetCategoryMetricsTotalWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetCategoryMetricsTotalWholeTeamQuery,
    protected readonly mapper: CategoryMetricsTotalWholeTeamParentAggregateRootMapper
  ) {}

  async get(
    props: GetCategoryMetricsTotalsWholeTeamRequestDto
  ): Promise<GetCategoryMetricsTotalsResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `CategoryMetricsTotalWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
